<template>
  <Menu></Menu>
  <div v-if="loading" class="loadingSpinner"><span class="spinner-border"></span></div>
  <div id="box">
    <!-- =========================================================================================================== -->
    <div class="container mb-2">
      <!-- ----------------------------------------------- -->
      <div class="row p-0">
        <div class="col p-0 text-center">
          <h5 class="fw-bold d-inline-block bi-alt">&nbsp; Manage Other Products</h5>
        </div>
        <div class="col-auto p-0 text-center">
          <button class="btn btn-dark w-100 bi-arrow-clockwise" @click="loadOthers()" :disabled="loading">&nbsp; Reload</button>
        </div>
      </div>
      <!-- ----------------------------------------------- -->
      <div class="row p-0">
        <div class="col p-0">
          <hr>
        </div>
      </div>
      <!-- ----------------------------------------------- -->          
      <div class="row p-0">

        <div class="col p-0">
          <div class="input-group w-100">
            <span class="input-group-text bi-search"></span>
            <input class="form-control" type="text" placeholder="Search by name" v-model.trim='filter'>
          </div>
        </div>
        
        <div class="col p-0">
        </div>
        
        <div class="col">
        </div>

        <div class="col  p-0">
          <button class="btn btn-success w-100" @click="showAddOther()" :disabled="loading">
            <span class="bi-plus-circle">&nbsp; Add Other</span>
          </button>
        </div>

      </div>
    </div>
    <!-- =========================================================================================================== -->
    <table class="table table-sm table-bordered table-striped table-hover table-fixed">
      <!-- ----------------------------------------------- -->
      <thead>
        <tr class="table-dark">
          <th class="">Name</th>
          <th class="w-25">barcode</th>
          <th v-if="$store.getters.access('cost')" class="w-10 text-center">Cost</th>
          <th v-if="$store.getters.access('price')" class="w-10 text-center">Price</th>
          <th class="text-center w-50px"><span class="bi-gear"></span></th>
        </tr>
      </thead>
      <!-- ----------------------------------------------- -->
      <tbody style="height: calc(100vh - 190px)">        
        <tr v-for="other in others_filtered" :key="other._id">
          <td class="">{{ other.name }}</td>
          <td class="w-25">{{ other.barcode }}</td>
          <td v-if="$store.getters.access('cost')" class="w-10 text-center">{{ other.cost }}</td>
          <td v-if="$store.getters.access('price')" class="w-10 text-center">{{ other.price }}</td>
          <td class="dropstart text-center w-50px">
            <a data-bs-toggle='dropdown' class="btn btn-sm btn-secondary p-1"><span class="bi-three-dots-vertical"></span></a>
            <ul class="dropdown-menu">
              <li><a class="dropdown-item bi-pencil-fill" @click="showEditOther(other)">Edit</a></li>
              <li><a class="dropdown-item bi-trash text-danger" @click="delOther(other)">Delete</a></li>
            </ul>
          </td>
        </tr>
      </tbody>
      <!-- ----------------------------------------------- -->
    </table>
    <!-- =========================================================================================================== -->
    <div id="addOtherModal" ref="addOtherModal" class="modal fade">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <!-- ----------------------------------------------- -->
          <div class="modal-header">
            <h5 class="modal-title">Add Other Product</h5>
            <a class="btn-close" data-bs-dismiss='modal'></a>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-body text-center">
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Name</span>
              <input class="form-control" type="text" v-model.trim="newOther.name">
            </div>
            <div v-if="$store.getters.access('cost_edit')" class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Cost</span>
              <input class="form-control" type="number" v-model.trim="newOther.cost">
            </div>
            <div v-if="$store.getters.access('price_edit')" class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Price</span>
              <input class="form-control" type="number" v-model.trim="newOther.price">
            </div>
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Barcode</span>
              <input class="form-control" type="text" v-model.trim="newOther.barcode" @input="barcodeChangedNew()" @change="barcodeChangedNew()">
            </div>
            <svg v-bind:class="newOther.barcode ? '' : 'd-none'" class="barcode" ref="newBarcode"></svg>
            <!-- <vue3-barcode v-bind:value="newOther.barcode" :height="50" /> -->
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-footer">
            <div class="container">
              <div class="row">
                <div class="col">
                  <a class="btn btn-secondary w-100" data-bs-dismiss='modal'>Cancel</a>
                </div>
                <div class="col">
                  <a class="btn btn-success w-100" @click="addOther()">Add</a>
                </div>
              </div>
            </div>
          </div>
          <!-- ----------------------------------------------- -->
        </div>
      </div>
    </div>
    <!-- =========================================================================================================== -->
    <div id="editOtherModal" ref="editOtherModal" class="modal fade">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <!-- ----------------------------------------------- -->
          <div class="modal-header">
            <h5 class="modal-title">Edit Product: {{ editOther.nameOriginal }}</h5>
            <a class="btn-close" data-bs-dismiss='modal'></a>
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-body text-center">
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Name</span>
              <input class="form-control" type="text" v-model.trim="editOther.name">
            </div>
            <div v-if="$store.getters.access('cost_edit')" class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Cost</span>
              <input class="form-control" type="number" v-model.trim="editOther.cost">
            </div>
            <div v-if="$store.getters.access('price_edit')" class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Price</span>
              <input class="form-control" type="number" v-model.trim="editOther.price">
            </div>
            <div class="input-group w-100 mb-2">
              <span class="input-group-text w-25">Barcode</span>
              <input class="form-control" type="text" v-model.trim="editOther.barcode" @input="barcodeChangedEdit()" @change="barcodeChangedEdit()">
            </div>
            <svg v-bind:class="editOther.barcode ? '' : 'd-none'" class="barcode" ref="editBarcode"></svg>
            <!-- <vue3-barcode v-bind:value="editOther.barcode" :height="50" /> -->
          </div>
          <!-- ----------------------------------------------- -->
          <div class="modal-footer">
            <div class="container">
              <div class="row">
                <div class="col">
                  <a class="btn btn-secondary w-100" data-bs-dismiss='modal'>Cancel</a>
                </div>
                <div class="col">
                  <a class="btn btn-success w-100" @click="saveOther()">Save</a>
                </div>
              </div>
            </div>
          </div>
          <!-- ----------------------------------------------- -->
        </div>
      </div>
    </div>
    <!-- =========================================================================================================== -->
  </div>

</template>
<!-- ******************************************************** -->
<script>
  const $ = require('jquery');
  var JsBarcode = require("jsbarcode");
  export default {
    name: 'OthersPage',
    data(){
      return {
        loading: false,
        others: [],
        filter: '',

        newOther:{
          name: '',
          barcode: '',
          cost: 0,
          price: 0,
        },
        editOther:{
          id: '',
          name: '',
          nameOriginal: '',
          barcode: '',
          cost: 0,
          price: 0,
        },
      }
    },
    async created() {
      await this.loadOthers();
      var code = "", reading = false;
      document.addEventListener('keypress', (e) => {
        if (e.keyCode === 13) {
            if(code.length >= 8) {
              this.onBarcodeScan(code);
              code = "";
            }
        }
        else { code += e.key; }
        if(!reading) {
            reading = true;
            setTimeout(() => { code = ""; reading = false;}, 200);
        }
      });
    },
    //**********************************************************
    computed:{
      others_filtered(){
        let filter = this.filter.toLowerCase();
        return this.others.filter((x)=>{
          if(x.barcode && x.barcode.toLowerCase().includes(filter)) return true;
          if(x.name && x.name.toLowerCase().includes(filter)) return true;
          if(x._id && x._id.toLowerCase().includes(filter)) return true;
          return false;
        });
      }
    },
    //**********************************************************
    methods:{
      //**********************************************************
      async loadOthers(){
        this.loading = true;
        this.others = [];
        var ack = await this.$service.getOthers();
        if(ack.state != 'OK'){
          this.$toast(ack.state);
        }
        else{
          this.others = ack.data;
        }
        this.loading = false;
      },
      //**********************************************************
      async onBarcodeScan(code){
        if($('#addOtherModal').hasClass('show')){
          this.newOther.barcode = code;
          this.barcodeChangedNew();
        }
        else if($('#editEditModal').hasClass('show')){
          this.editOther.barcode = code;
          this.barcodeChangedEdit();
        }
        else this.filter = code;
      },
      //**********************************************************
      async showAddOther(){
        this.clearFields();
        $('#addOtherModal').modal('show');
      },
      //**********************************************************
      async clearFields(){
        this.newOther = {
          name: '',
          barcode: '',
          cost: 0,
          price: 0,
        }
      },
      //**********************************************************
      async addOther(){
        this.loading = true;
        await this._addOther();
        this.loading = false;
      },
      //**********************************************************
      async _addOther(){
        if(!this.newOther.name){
          return this.$toast('Some Fields are empty', 'warning');
        }
        this.loading = true;
        var ack = await this.$service.addOther({
          name: this.newOther.name,
          barcode: this.newOther.barcode,
          cost: this.newOther.cost,
          price: this.newOther.price,
        });
        if(ack.state != 'OK') return this.$toast(ack.state);
        $('#addOtherModal').modal('hide');
        this.$toast('Product Added Successfuly', 'success');
        this.loading = false;
        await this.loadOthers();
      },
      //**********************************************************
      async showEditOther(other){
        this.editOther.id = other._id;
        this.editOther.nameOriginal = other.name;
        this.editOther.name = other.name;
        this.editOther.barcode = other.barcode;
        this.editOther.cost = other.cost;
        this.editOther.price = other.price;
        this.barcodeChangedEdit();
        $('#editOtherModal').modal('show');
      },
      //**********************************************************
      async saveOther(){
        this.loading = true;
        await this._saveOther();
        this.loading = false;
      },
      //**********************************************************
      async _saveOther(){
        if(!this.editOther.name){
          return this.$toast('Some Fields are empty', 'warning');
        }
        this.loading = true;
        var ack = await this.$service.editOther({
          id: this.editOther.id,
          name: this.editOther.name,
          barcode: this.editOther.barcode,
          cost: this.editOther.cost,
          price: this.editOther.price,
        });
        if(ack.state != 'OK') return this.$toast(ack.state);
        $('#editOtherModal').modal('hide');
        this.$toast('Product Saved Successfuly', 'success');
        this.loading = false;
        await this.loadOthers();
      },
      //**********************************************************
      async delOther(other){
        this.$confirm({
          title: 'Confirm Delete',
          message: `Are you sure you want to delete the product ${other.name}`,
          disableKeys: false, auth: false, button: { no: 'Cancel', yes: 'Yes, Delete'},
          callback: async (confirm) => {
            if(confirm){
              this.loading = true;
              var ack = await this.$service.delOther({ id: other._id });
              if(ack.state != 'OK') return this.$toast(ack.state);
              this.$toast('Product Deleted Successfuly', 'success');
              this.loading = false;
              await this.loadOthers();
            }
          }
        });
        // this.loading = false;
      },
      //**********************************************************
      //**********************************************************
      //**********************************************************
      //**********************************************************
      //**********************************************************
      barcodeChangedNew(){
        if(!this.newOther.barcode) return;
        JsBarcode(this.$refs.newBarcode, this.newOther.barcode)
      },
      barcodeChangedEdit(){
        if(!this.editOther.barcode) return;
        JsBarcode(this.$refs.editBarcode, this.editOther.barcode)
      }
      //**********************************************************
    }
  }
</script>
<!-- ******************************************************** -->
<style scoped>
</style>
  